import { render, staticRenderFns } from "./TrxMatchList.vue?vue&type=template&id=2e1376b2&"
import script from "./TrxMatchList.vue?vue&type=script&lang=js&"
export * from "./TrxMatchList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports